export default __webpack_public_path__ + "static/media/code.0aa7d045.jpg";